import React, { useState } from 'react'
import ScrollToTop from '../components/ScrollToTop';
import Footer from '../components/Footer';
import About from '../components/AboutForms';
import NavbarHeader from '../components/NavbarHeader';
import { Account } from '../components/Accounts'

function AboutPage() {

    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className='about'>
        <Account>           
            <ScrollToTop />
            <NavbarHeader toggle={toggle} />
            <About />
            <Footer />
        </Account>
        </div>
    );
}

export default AboutPage;